/**
 * Resolves the API base URL at runtime.
 *
 * Strategy: on Emergent (both preview and production), the frontend and the /api/*
 * routes are served from the SAME host. So we just use `window.location.origin`,
 * which makes the bundle immune to any wrong REACT_APP_BACKEND_URL value that
 * might have been baked in during a previous build.
 *
 * Only exception: when running locally during dev (npm start on localhost),
 * we respect REACT_APP_BACKEND_URL so developers can point at a remote backend.
 */
const envUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

function resolveBackendUrl() {
  if (typeof window === 'undefined') return envUrl;

  const host = window.location.hostname;
  const isLocalDev =
    host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.');

  // In local dev, honor the env var so developers can point at any backend.
  if (isLocalDev && envUrl) return envUrl;

  // Everywhere else (preview, production, custom domain) → same origin as the page.
  return window.location.origin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
